import { useTranslation } from '@core/translation';

export const useOnboardingTranslation = () => useTranslation('ONBOARDING');

export const usePriceSuggestionTranslation = () =>
  useTranslation('ONBOARDING.PRICE_SUGGESTION_SCREEN');
